import { Routes, Route, useLocation } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import { AuthProvider } from './contexts/AuthContext'
import { ProfileProvider } from './contexts/ProfileContext'
import { ToastProvider } from './contexts/ToastContext'
import Navigation from './components/Navigation'
import Home from './pages/Home'
import Login from './pages/Login'
import Register from './pages/Register'
import Search from './pages/Search'
import Profiles from './pages/Profiles'
import Curate from './pages/Curate'
import BookmarkImport from './pages/BookmarkImport'
import Networks from './pages/Networks'
import Trust from './pages/Trust'
import CopyTrust from './pages/CopyTrust'
import TrustLists from './pages/TrustLists'
import Settings from './pages/Settings'
import AdminReports from './pages/admin/AdminReports'
import AdminHiddenContent from './pages/admin/AdminHiddenContent'
import About from './pages/About'
import Invite from './pages/Invite'
import PrivateRoute from './components/PrivateRoute'
import BottomNav from './components/BottomNav'
import './App.css'

function AppContent() {
  const location = useLocation()
  const isHomePage = location.pathname === '/'

  // Home page has its own full-screen layout
  if (isHomePage) {
    return <Home />
  }

  return (
    <div className="App">
      <Navigation />
      <Container className="mt-4">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected routes */}
          <Route path="/search" element={
            <PrivateRoute>
              <Search />
            </PrivateRoute>
          } />
          <Route path="/profiles" element={
            <PrivateRoute>
              <Profiles />
            </PrivateRoute>
          } />
          <Route path="/curate" element={
            <PrivateRoute>
              <Curate />
            </PrivateRoute>
          } />
          <Route path="/import-bookmarks" element={
            <PrivateRoute>
              <BookmarkImport />
            </PrivateRoute>
          } />
          <Route path="/networks" element={
            <PrivateRoute>
              <Networks />
            </PrivateRoute>
          } />
          <Route path="/trust" element={
            <PrivateRoute>
              <Trust />
            </PrivateRoute>
          } />
          <Route path="/copy-trust" element={
            <PrivateRoute>
              <CopyTrust />
            </PrivateRoute>
          } />
          <Route path="/trust-lists" element={
            <PrivateRoute>
              <TrustLists />
            </PrivateRoute>
          } />
          <Route path="/settings" element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          } />

          {/* Admin routes */}
          <Route path="/admin/reports" element={
            <PrivateRoute>
              <AdminReports />
            </PrivateRoute>
          } />
          <Route path="/admin/hidden-content" element={
            <PrivateRoute>
              <AdminHiddenContent />
            </PrivateRoute>
          } />

          {/* About page */}
          <Route path="/about" element={
            <PrivateRoute>
              <About />
            </PrivateRoute>
          } />

          {/* Invite page */}
          <Route path="/invite" element={
            <PrivateRoute>
              <Invite />
            </PrivateRoute>
          } />
        </Routes>
      </Container>
      <BottomNav />
    </div>
  )
}

function App() {
  return (
    <AuthProvider>
      <ProfileProvider>
        <ToastProvider>
          <Routes>
            <Route path="/*" element={<AppContent />} />
          </Routes>
        </ToastProvider>
      </ProfileProvider>
    </AuthProvider>
  )
}

export default App
